module.exports = __webpack_public_path__ + "img/密码读卡器.95a41767.jpg";